import React from 'react'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface EditButtonProps {
  text: string
  handleEdit?: () => void
}

export const EditButton: React.VFC<EditButtonProps> = ({ text, handleEdit }): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Button
      variant="outlined"
      onClick={handleEdit}
      sx={{
        fontSize: '14px',
        height: '32px',
        minWidth: '51px',
        width: '51px',
      }}
    >
      {t(text)}
    </Button>
  )
}
